var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPacketLossIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    viewBox: "0 0 24 14",
    width: "1em",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.82 6.732L16.705.103A.392.392 0 0016.451 0a.38.38 0 00-.256.103l-.86.804a.356.356 0 00-.118.262c0 .097.043.194.118.261L21.307 7l-5.972 5.57a.356.356 0 00-.118.261c0 .098.043.195.118.262l.86.804a.368.368 0 00.511 0l7.12-6.635A.356.356 0 0023.943 7a.402.402 0 00-.125-.268zM2.636 7l5.972-5.57a.356.356 0 00.118-.261.356.356 0 00-.118-.262l-.86-.804A.392.392 0 007.493 0a.38.38 0 00-.256.103L.118 6.738A.356.356 0 000 7a.36.36 0 00.118.262l7.12 6.635a.392.392 0 00.255.103.368.368 0 00.256-.103l.86-.804a.356.356 0 00.118-.262.356.356 0 00-.118-.261L2.637 7z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2.4,
    rx: 0.5,
    transform: "rotate(45 8 7)",
    width: 2.4,
    x: 6.8,
    y: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2.4,
    rx: 0.5,
    transform: "rotate(45 16 7)",
    width: 2.4,
    x: 14.8,
    y: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2.4,
    rx: 0.5,
    transform: "rotate(45 12 7)",
    width: 2.4,
    x: 10.8,
    y: 5.8
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPacketLossIcon);
export default __webpack_public_path__ + "static/media/packet_loss-icon.fb1679c0c1b547f3bfee5c371e03a08d.svg";
export { ForwardRef as ReactComponent };